import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Container from '@mui/material/Container';

function ProtectedRoute() {
  const isLoggedIn = true/* your authentication check here */; 
  const location = useLocation();
  const pathname = location.pathname.replace("/", "");
  document.title = pathname;
  const user = JSON.parse(window.localStorage.getItem("user"));
  const functions = JSON.parse(user.functions||"[]");
  if (pathname != '' && pathname != 'home' && (!isLoggedIn || !functions.find(f=>f.Form == pathname))) {
    return <Navigate to="/login" replace />;
  }

  return <>
    <Container maxWidth="xl" className='custom-container'>
      <Outlet />
    </Container>
  </>; // Renders the child routes if authenticated
}
export default ProtectedRoute;